import {useEffect, useState} from "react";

import React, { lazy, Suspense } from 'react';
import { useSelector } from "react-redux";
// import SwaggerUI from "swagger-ui-react";
import {trackPromise} from "react-promise-tracker";
// import BimetaDataService from "../../services/BimetaDataService";
import http from "../../shared/http-common";
import {useParams} from "react-router";

const SwaggerUI = lazy(() => import('swagger-ui-react'));

function DokuObject() {
    // const [treeItemsState] = useContext(TreeItemsStateContext);
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const { openApiJsonFile } = useParams()
    // // const [SiteColor] = useContext(SiteColorContext);
    // const [bimProfileSelected, setBimProfileSelected] = useContext(BimProfileSelectedContext);
    const [spec, setSpec] =  useState(null);
    const [, setIsLoading] = useState(false);

    const getApiDoc = async(openApiJsonFile) => {
        console.log('openApiJsonFile2: ' + openApiJsonFile)
        return await trackPromise(
            getdocfromserver(token, realm, openApiJsonFile)
        )
    }

    const getdocfromserver = (token, realm, openApiJsonFile) => {
        let formData = new FormData();
        formData.append("realm", realm);
        formData.append("openApiJsonFile", openApiJsonFile);
        console.log('openApiJsonFile3: ' + openApiJsonFile)
        console.dir(formData)
        return http.post(`/oaf/${realm}/api4`, formData, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    useEffect(() => {
        setIsLoading(true)
        console.log('openApiJsonFile: ' + openApiJsonFile)
        getApiDoc(openApiJsonFile).then(data => {
            setSpec(data.data);
            setIsLoading(false)
        })
    }, [openApiJsonFile]);

    return (
        <>
            <div style={{textAlign: "left"}}>
                <Suspense fallback={<div>Loading...</div>}>
                    <SwaggerUI spec={spec} ></SwaggerUI>
                </Suspense>
            </div>
        </>
    )
}
export default DokuObject;
